import { IMessageType } from '@/services/signalr/types';
import { ITripListReqMsg } from '~/api/messages/ITripListReqMsg';
import { ITripListRespMsg } from '~/api/messages/ITripListRespMsg';
import { ITripUpdateMsg } from '~/api/messages/ITripUpdateMsg';

export const TripListReqMsg: IMessageType<ITripListReqMsg, ITripUpdateMsg> = {
  requestName: 'TripListReqMsg',
  responseName: 'TripUpdateMsg',
};

export const TripListRespMsg: IMessageType<ITripListReqMsg, ITripListRespMsg> = {
  requestName: 'TripListReqMsg',
  responseName: 'TripListRespMsg',
};
